// extracted by mini-css-extract-plugin
export default {"content":"dataDelete_content__nDU40","bannerContainer":"dataDelete_bannerContainer__SOVHq","bannerButton":"dataDelete_bannerButton__yex27"};